import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className="footer ht-bg-move pb-sm-4"
      style={{ borderRadius: "30px", clipPath: "inset(0% 1.5014% round 30px)" }}
    >
      <div className="primary-footer footer-widget">
        <Container>
          <Row>
            {/* Logo and Description */}
            <Col xl={4} md={12} className="pe-lg-5">
              <a
                className="footer-logo d-block logo mb-2 text-decoration-none"
                href=""
              >
                <img src="../assets/images/logo.png" alt="" className="mt-1" />
                <h5 className="mb-0">
                  <div className="">
                    <div className="text-white">
                      <span className="d-block text-orange me-1 fw-bold">
                        Saryuparin
                      </span>
                      Brahman Samaj Rajasthan, Jaipur
                    </div>
                  </div>
                </h5>
              </a>
              <p className="footer-content text-white">
                We, the Saryuparin Brahman Samaj, are a vibrant community based
                in Rajasthan, committed to fostering unity, cultural heritage,
                and social welfare among Brahmins. Our mission is to preserve
                the values of our rich traditions while adapting to the evolving
                needs of society.
              </p>
              {/* Subscription Form */}
            </Col>

            {/* Contact Info */}
            <Col xl={4} md={6} sm={12} className="mt-md-5 mt-0">
              <h5 className="widget-title">Contact Us</h5>
              <ul className="media-icon list-unstyled">
                <li>
                  <i className="bi bi-house-door"></i>
                  <h6>Visit Our Location</h6>
                  <p className="text-white">
                    D – 237, Gautam Maga, Near Bright Future School,Nirman
                    Nagar, Jaipur, Rajasthan - 302019
                  </p>
                </li>
                <li>
                  <i className="bi bi-envelope-at"></i>
                  <h6>Send Us Email</h6>
                  <div>
                    <a
                      href="mailto:saruparisamaj18@gmail.com"
                      style={{ marginBottom: "0px" }}
                    >
                      saruparisamaj18@gmail.com
                    </a>{" "}
                    <br style={{ margin: "0px" }} />
                    <a href="mailto:saryuparivarraj@gmail.com">
                      saryuparivarraj@gmail.com
                    </a>
                  </div>
                </li>
                <li>
                  <i className="bi bi-telephone-inbound"></i>
                  <h6>Our Contact Information</h6>
                  <a href="tel:+918559875266">0141-2810355, 91-8559875266</a>
                  <br />
                  <a href="tel:+919413196107">91-9413196107, 91-9610425551</a>
                </li>
              </ul>
            </Col>

            {/* Footer Menus */}
            <Col xl={4} md={6} className="mt-md-5 mt-0">
              <Row>
                {/* Company Links */}
                <Col xs={6}>
                  <h5 className="widget-title">Company</h5>
                  <ul className="menu list-unstyled">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About us</Link>
                    </li>
                    <li>
                      <Link to="/events">Events</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    {/* <li>
                      <Link to="">Privacy Policy</Link>
                    </li> */}
                  </ul>
                </Col>
                {/* Services Links */}
                <Col xs={6}>
                  <h5 className="widget-title">Our Service</h5>
                  <ul className="menu list-unstyled">
                    <li>
                      <Link to="">Matrimonial</Link>
                    </li>
                    <li>
                      <Link to="">Job & Career</Link>
                    </li>
                    <li>
                      <Link to="">Community Directory</Link>
                    </li>
                    <li>
                      <Link to="">Business Directory</Link>
                    </li>
                    <li>
                      <Link to="">Marketing Strategy</Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Secondary Footer */}
      <div className="secondary-footer mt-3">
        <Container>
          <Row className="align-items-center">
            <Col lg={12}>
              <p className="mb-0 text-center ">
                Copyright 2024 Website by{" "}
                <a href="/about" className="text-orange text-decoration-none">
                  Triyugi Technologies
                </a>{" "}
                | All Rights Reserved
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
